// import "./modules/HelloWorld";

// Some cool modules
import "./modules/Animate";
import "./modules/ToggleBodyClass";
import "./modules/ScrollClass";
import "./modules/CardCarousel";
import "./modules/Partners";
import "./modules/Fancybox";
import DonationForm from "./modules/DonationForm";

// Initialize donation form
new DonationForm();
